import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DataTypeEnum } from 'src/app/constants/data-type.enum';
import { DocumentModel } from 'src/app/models/document.model';
import { CreateColumn, TableColumn } from 'src/app/models/tableColumn';

export const DocumentDetailsModalOptions: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  centered: true,
  size: 'md'
};

@Component({
    templateUrl: './document-details.modal.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DocumentDetailsModal {
  @Input() document!: DocumentModel;

  public columnsToDisplay: TableColumn[] = [
    CreateColumn<DocumentModel>("documentType", 'Type', DataTypeEnum.DocumentType, 2, true),
    CreateColumn<DocumentModel>("fileSize", 'FileSize', DataTypeEnum.FileSize, 2, true),
    CreateColumn<DocumentModel>("id", 'Id', DataTypeEnum.Guid, 2, true),
    CreateColumn<DocumentModel>("hash", 'Hash', DataTypeEnum.Hash, 2, true),
  ];

  constructor(private activeModal: NgbActiveModal) {
  }

  public closeModal() {
    this.activeModal.close();
  }
}
